import React, { ReactNode } from 'react';

const PurchaserDashboard: React.FC = () => {
    return (
        <>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-2.5">
                PurchaserDashboard
            </div>

            <div className="mt-4 grid grid-cols-12 gap-4 md:mt-6 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                PurchaserDashboard
            </div>
        </>        
    );
};

export default PurchaserDashboard;